module.exports = __webpack_public_path__ + "img/chat-right-quote.af1bee69.svg";